module.exports = __webpack_public_path__ + "static/media/unity.6f3b16db.svg";